import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminHeader, Panel, EmptyState } from "@/components/admin/ui";

const ACTION_COLOR = { create: "text-emerald-400", update: "text-[#D8AE4E]", delete: "text-red-400", login: "text-sky-400", reorder: "text-purple-400", upload: "text-emerald-400" };

export default function Audit() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/audit").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const filtered = items.filter((a) =>
    [a.user_email, a.action, a.resource, a.detail].join(" ").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div>
      <AdminHeader title="Audit Trail" subtitle="Immutable record of all administrative actions." />
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search actions…" className="w-full sm:max-w-xs bg-[#06122E] border border-[#203E70] rounded px-3 py-2.5 text-sm text-white mb-6 outline-none focus:border-[#D8AE4E]/50" data-testid="audit-search" />
      {filtered.length === 0 ? <Panel><EmptyState>No audit records.</EmptyState></Panel> : (
        <Panel className="overflow-x-auto admin-scroll">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-slate-500 border-b border-[#203E70]">
              <th className="px-5 py-3 font-medium">User</th>
              <th className="px-5 py-3 font-medium">Action</th>
              <th className="px-5 py-3 font-medium">Resource</th>
              <th className="px-5 py-3 font-medium">Detail</th>
              <th className="px-5 py-3 font-medium">Time</th>
            </tr></thead>
            <tbody>
              {filtered.map((a) => (
                <tr key={a.id} className="border-b border-[#203E70] last:border-0" data-testid={`audit-row-${a.id}`}>
                  <td className="px-5 py-3 text-white whitespace-nowrap">{a.user_name || a.user_email}</td>
                  <td className={`px-5 py-3 font-medium ${ACTION_COLOR[a.action] || "text-slate-300"}`}>{a.action}</td>
                  <td className="px-5 py-3 text-slate-300">{a.resource}</td>
                  <td className="px-5 py-3 text-slate-400">{a.detail}</td>
                  <td className="px-5 py-3 text-slate-600 font-mono text-xs whitespace-nowrap">{new Date(a.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Panel>
      )}
    </div>
  );
}
